import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import config from "../../config";

const DataIntgApiDocs: React.FC = (props) => {
  const openapiUrl = `https://${config.dataIntegration.domain}/docs/v1/openapi.json`;

  return (
    <div className="w-full min-h-screen">
      <SwaggerUI url={openapiUrl} />
    </div>
  );
};

export default DataIntgApiDocs;
